import React from 'react';
import moment from 'moment';
import OddConverter from "@common/helpers/oddConverter";
import { t } from '../../../../helpers/translator';
import Config from "../../../../config/main";
import { BetStateEnum, BetStateViewEnum } from '../../../../constants/enums/betState';
import { getCasinoTicketItemState, getTicketState } from '../../../../helpers/tickets';
import { BETSLIP_TYPE_SYSTEM } from '../../../../helpers/sport/betslip';
import CountDown from '../../countdownHook';

const disabledStates = [BetStateEnum.Accepted, BetStateEnum.Lost, BetStateEnum.Rejected, BetStateEnum.NotResulted];

const amountClassNames = {
    [BetStateEnum.Accepted]: 'pending-ticket',
    [BetStateEnum.Returned]: 'returned-ticket',
    [BetStateEnum.Lost]: 'lost-ticket',
    [BetStateEnum.Won]: 'won-ticket',
};

export function sportTicketsColumnConfig() {
    let { currency } = JSON.parse(sessionStorage.getItem("authData"));
    const { earlyCashout } = this.props;
    const predefined_multiple_id = this.props.data?.predefined_multiple_id;
    const { checked, paiedTickets, earlyCashoutedBets } = this.state;

    return [
        {
            name: () => <>
                <label className={`ticket-container-check`}>
                    <input
                        className='input-check'
                        type="checkbox"
                        checked={this.sportTickets.filter(item => item.isActive).every(item => item.isChecked)}
                        onChange={() => this.toggleAllSportTickets()}
                    />
                    <span className="checkmark">
                    </span>
                </label>
                {t("Bet")} ({this.sportTickets.length})
            </>,
            row: item => {
                const checkedItem = checked[item.barcode];

                const isLoading = this.state.isLoading && checkedItem && !checkedItem.enableRemoveCounter;
                const isEarlyCashouted = item.cashout_amount && (earlyCashoutedBets?.[item.barcode] || earlyCashout?.[item.barcode]);
                const ticketState = getTicketState(item);
                const winAmount = item.casinoTicket ? item.dataFromSwarm.WinAmount : item.win_amount
                const checkboxDisabled = !winAmount || isEarlyCashouted || paiedTickets?.[item.barcode];
                
                return <>
                    {isLoading && <div className="sk-chase">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>}
                    {!isLoading && ticketState === BetStateEnum.Accepted && <button
                        className="tickets-refresh-button"
                        onClick={e => this.onRefreshClick(e, item.casino_barcode || item.barcode)}
                    />}
                    <label className={`ticket-container-check ${checkboxDisabled ? 'disabled' : ''}`}>
                        <input
                            className='input-check'
                            disabled={checkboxDisabled}
                            type="checkbox"
                            checked={!!checkedItem}
                            onChange={() => this.toggleTicket(item)}
                        />
                        <span className="checkmark">
                        </span>
                    </label>
                    <p>{t(BetStateViewEnum[ticketState] || item.bet_state_name)}</p>
                    {checkedItem?.enableRemoveCounter && <span className="ticket-remove-counter">
                        {t("The ticket will be automatically removed after")}
                        &nbsp;
                        <CountDown
                            propsDefaultSecond={Config.ticketPopupRemoveCounterSeconds}
                            endOfWork={() => this.removeTicket(item.barcode)}
                        />
                        &nbsp;
                        {t("seconds")}
                    </span>}
                </>;
            },
        },
        {
            name: () => t("Type"),
            row: item => <p className={predefined_multiple_id ? 'sport-type' : ''}>
                {item.betType || '-'}
                {item.betTypeId === BETSLIP_TYPE_SYSTEM && `(${item.system_min_count}/${item.selectionCount})`}
            </p>,
        },
        {
            name: () => t("Amount"),
            row: item => <p>{item.betAmount || item.dataFromSwarm.Amount || 0} {Config.enableCurrencyView && currency.toUpperCase()}</p>,
        },
        {
            name: () => t("Price"),
            row: item => <p>{item.price || '-'}</p>,
        },
        {
            name: () => t("Won Amount"),
            row: item => {
                const state = getTicketState(item);
                let calculatedWinAmount = item.win_amount - item.tax_amount
                let winAmount;

                if (!item.casinoTicket && calculatedWinAmount === 0 && state === BetStateEnum.Won) winAmount = 0
                else winAmount = parseFloat((calculatedWinAmount || (
                    item.casinoTicket && state === BetStateEnum.Accepted ? ((item.dataFromCasino?.PossibleWin - item.dataFromCasino?.PossibleTaxAmount) || 0) : (state === BetStateEnum.Won || state === BetStateEnum.Rollbacked) ? (item.dataFromSwarm.WinAmount) : 0)
                 || (item.bet_state_id === BetStateEnum.Lost && "0") || (item.possibleWin - item.possible_tax_amount) || item.dataFromCasino?.WinAmount || 0)).toFixed(2)

                return (
                    <p className={`add-v-t ${amountClassNames[state] || ''}`}> 
                        {winAmount} {Config.enableCurrencyView && currency.toUpperCase()}
                    </p>
                )
            }
        },
        {
            name: () => t("Date"),
            row: item => moment(item.created || item.dataFromSwarm.Created || item.dataFromCasino.DrawDate).format("DD/MM/YYYY HH:mm:ss") || null,
        },
        {
            columnClassName: 'cashout-icon-column',
            rowClassName: 'cashout-icon-row',
            row: item => item.cashout_amount && earlyCashoutedBets?.[item.barcode] ||
                (earlyCashout?.[item.barcode])
                ? null
                : item.cashout_amount && !Config.main.disableCashoutBet && <span className="ticket-cash-icon"></span>,
        },
    ];
}

export function casinoBetTicketsColumnConfig() {
    const { dataFromSwarm } = this.props;
    const { currency } = JSON.parse(sessionStorage.getItem("authData"));

    return [
        {
            name: () => t("Amount"),
            row: item => <p>{item.BetAmount || 0} {Config.enableCurrencyView && currency.toUpperCase()}</p>,
        },
        {
            name: () => t("Price"),
            row: item => <p>{OddConverter(item.Odds) || null}</p>,
        },
        {
            name: () => t("Won Amount"),
            row: item => {
                const state = getTicketState({ dataFromSwarm, dataFromCasino: item });
                return (
                    <p className={`add-v-t ${amountClassNames[state] || ''}`}>
                        {item.win_info?.WinAmount ? parseFloat(item.win_info?.WinAmount - item.win_info?.TaxAmount).toFixed(2) : 0.00} {Config.enableCurrencyView && currency.toUpperCase()}
                    </p>
                )
            }
        },
        {
            name: () => t("Date"),
            row: item => {
                const drawDateExists = !item.DrawDate.startsWith('1970') && !item.DrawDate.startsWith('0001');
                return drawDateExists ? moment(item.DrawDate).format("DD/MM/YYYY HH:mm:ss") : '-';
            }
        },
    ];
}

export function cashoutTicketsColumnConfig() {
    const { paiedTickets, checked, isLoading } = this.state;

    return [
        {
            name: () => <>
                <label className={`ticket-container-check`}>
                    <input
                        className='input-check'
                        type="checkbox"
                        checked={this.cashoutTickets.filter(item => item.isActive).every(item => item.isChecked)}
                        onChange={() => this.toggleAllCashoutTickets()}
                    />
                    <span className="checkmark">
                    </span>
                </label>
                {t("Cashout")} ({this.cashoutTickets.length})
            </>,
            row: item => <>
                {isLoading && checked[item.barcode] && <div className="sk-chase">
                    <div className="sk-chase-dot"></div>
                    <div className="sk-chase-dot"></div>
                    <div className="sk-chase-dot"></div>
                    <div className="sk-chase-dot"></div>
                    <div className="sk-chase-dot"></div>
                    <div className="sk-chase-dot"></div>
                </div>}
                <label className={`ticket-container-check ${disabledStates.includes(item.bet_state_id) ? 'disabled' : ""}${paiedTickets?.[item.barcode]?.success ? "won"
                    : paiedTickets?.[item.barcode]?.message ? "lost" : ''}`}>
                    <input
                        className='input-check'
                        // name="isGoing"
                        checked={checked[item.barcode] || paiedTickets?.[item.barcode]}
                        disabled={disabledStates.includes(item.bet_state_id) || paiedTickets?.[item.barcode]}
                        type="checkbox"
                        // checked={isGoing}
                        onChange={() => this.toggleTicket(item)}
                    />
                    <span className="checkmark">
                    </span>
                </label>
                <p className={paiedTickets?.[item.barcode]?.success ? "won"
                    : paiedTickets?.[item.barcode]?.message ? "lost" : ''} />
            </>,
        },
        {
            name: () => t("Amount"),
            row: item => item.amount,
        },
        {
            name: () => t("Date"),
            row: item => moment(item.created).format("DD/MM/YYYY HH:mm:ss") || null,
        },
    ];
}

export function sportTicketsInfoColumnConfig() {
    return [
        {
            name: () => t('Match Name'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.game_name
        },
        {
            name: () => t('Market - selection'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.event_name
        },
        {
            name: () => t('Odd'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.price
        },
        {
            name: () => t('Event result'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => <p className='match_result'>
                {this.state.scores && this.state.scores[item.match_id] ? this.state.scores[item.match_id] : "-"}
            </p>
        },
        {
            name: () => t('Start date'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => <div className="match-day">
                <p>{moment(item.start_date_time).format("DD/MM/YYYY HH:mm:ss")}</p>
            </div>
        },
        {
            name: '',
            columnClassName: 'multiple-wins-popup-info-state',
            rowClassName: 'multiple-wins-popup-info-state',
            row: item => <span className={`status-view-b-t ${item.state === 0 ? "pending" : item.state === 3 ? "lost" : item.state === 2 ? "returned" : item.state === 6 ? "LoseReturn" : item.state === 1 ? "win-sp" : "win"}`} />
        }
    ];
}

export function casinoTicketsInfoColumnConfig() {
    return [
        {
            name: () => t('Game Name'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => item.GameName,
        },
        {
            name: () => t('Market - selection'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => <>
                <p>{item.MarketName}</p>
                <p>{item.SelectionName}</p>
            </>,
        },
        {
            name: () => t('Draw date'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: (item) => {
                const drawDateExists = !item.DrawDate.startsWith('1970') && !item.DrawDate.startsWith('0001');
                return drawDateExists ? moment(item.DrawDate).format(Config.main.dateTimeFormat) : '-';
            }

        },
        {
            name: () => t('Numbers'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => <ul className="outgoing-numbers">
                {item.Numbers && item.Numbers.length !== 0 ? item.Numbers[0].sort((a, b) => a - b).map((number, index) =>
                    <li className={`add-v-t ${item.Settled && item.Result && item.Result.numbers &&
                        item.Result.numbers.length !== 0 && item.Result.numbers[0] !== null && item.Result.numbers[0].includes(number) ? 'lottery-number-ball' : ''}`} key={index}><span>{number}</span> </li>
                ) : <li>
                </li>}
            </ul>,
        },
        {
            name: () => t('State'),
            rowClassName: 'multiple-wins-popup-info-row',
            row: item => {
                const state = getCasinoTicketItemState(item);

                return <p className={`status-view-b-t ${amountClassNames[state]}`}>
                    <span>{t(BetStateViewEnum[state])}</span>
                </p>
            }
        }
    ];
}

